import { Box, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CandidateMatchDashboardHeaderSkeleton } from 'features/Connect/components/LoadingSkeletons/MatchDashboardHeaderLoadingSkeleton';
import { MatchArchiveFilterButtonGroup } from 'features/Connect/components/Buttons/MatchArchiveFilterButtonGroup';
import { CandidateMatchArchiveDashboardHeaderProps } from './utils/types';

export const CandidateMatchArchiveDashboardHeader: React.FC<
  CandidateMatchArchiveDashboardHeaderProps
> = ({
  isUserOpenToWorkAndMatches,
  hasInitiallyFetchedMatches,
  shouldShowDashboard,
  filteredArchivedMatchesLength,
  activeFilter,
  onFilterChange,
  hasAcceptedMatches,
  hasRejectedMatches,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <MatchArchiveDashboardHeaderContainer>
      {isUserOpenToWorkAndMatches &&
        (!hasInitiallyFetchedMatches ? (
          <CandidateMatchDashboardHeaderSkeleton />
        ) : (
          shouldShowDashboard && (
            <ArchiveHeaderContent>
              <MatchArchiveHeaderCountText>
                Showing {filteredArchivedMatchesLength} archived match
                {filteredArchivedMatchesLength !== 1 ? 'es' : ''}
              </MatchArchiveHeaderCountText>

              {!isMobile && (
                <MatchArchiveFilterButtonGroup
                  activeFilter={activeFilter}
                  onFilterChange={onFilterChange}
                  hasAcceptedMatches={hasAcceptedMatches}
                  hasRejectedMatches={hasRejectedMatches}
                />
              )}
            </ArchiveHeaderContent>
          )
        ))}
    </MatchArchiveDashboardHeaderContainer>
  );
};

const MatchArchiveDashboardHeaderContainer = styled(Box)({
  width: '100%',
});

const ArchiveHeaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const MatchArchiveHeaderCountText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.light,
  fontSize: theme.typography.subtitle.fontSize,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: theme.typography.h2.lineHeight,
  letterSpacing: '0.25px',
}));
